import { ENQUEUE_SNACKBAR, REMOVE_SNACKBAR } from './actions';

import type { Notification } from '@/types';

export interface NotifierAction {
  type?: string;
  key?: string;
  notification?: Notification;
  [key: string]: unknown;
}

const notifierReducer = (state: Notification[] = [], action: NotifierAction): Notification[] => {
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return [
        {
          key: action.key ?? '',
          message: action.notification?.message ?? '',
          ...action.notification,
          options: {
            ...action.notification?.options,
          },
        },
      ];

    case REMOVE_SNACKBAR:
      return state.filter(notification => notification.key !== action.key);

    default:
      return state;
  }
};

export { notifierReducer };
